import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSlider from './components/HeroSlider';
import ServicesSection from './components/ServicesSection';
import NewsSection from './components/NewsSection';
import WorksSection from './components/WorksSection';
import TestimonialsSection from './components/TestimonialsSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';
import { useSEO } from '../../utils/seo';

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useSEO({
    title: '岡山市の印刷会社｜記念品・販促物印刷のおかやま印刷株式会社',
    description: '岡山市で40年の実績。マグカップ、Tシャツ、ステンレスボトルなど多彩な印刷技術でお客様の想いをカタチに。卒団記念品や販促物の制作はおかやま印刷株式会社にお任せください。親身な対応で地域密着のサービスを提供します。',
    keywords: '岡山市印刷,記念品印刷,シルク印刷,レーザー印刷,マグカップ印刷,Tシャツ印刷,卒団記念品,販促物印刷,おかやま印刷',
    canonical: '/',
    ogType: 'website',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'おかやま印刷株式会社',
      image: 'VITE_SITE_URL/logo.png',
      description: '岡山市で40年の実績を持つ印刷会社。紙印刷からシルク印刷、レーザー印刷まで多彩な技術でマグカップ、Tシャツ、ステンレスボトルなど幅広い印刷サービスを提供。',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '北区○○町1-2-3',
        addressLocality: '岡山市',
        addressRegion: '岡山県',
        postalCode: '700-0000',
        addressCountry: 'JP',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 34.6617,
        longitude: 133.935,
      },
      url: 'VITE_SITE_URL/',
      telephone: '+81-86-012-3456',
      faxNumber: '+81-86-012-3457',
      openingHoursSpecification: {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        opens: '09:00',
        closes: '18:00',
      },
      foundingDate: '1992',
      priceRange: '$$',
    },
  });

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <h1 className="sr-only">おかやま印刷株式会社</h1>
        <HeroSlider />
        <ServicesSection />
        <NewsSection />
        <WorksSection />
        <TestimonialsSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
